import React from 'react';
import { ArrowLeft } from 'lucide-react';
import LiveCampaignBanner from './LiveCampaignBanner';

interface TriggerSubScreenLayoutProps {
  onBack: () => void;
  backLabel?: string;
  showLiveBanner?: boolean;
  hideBackButton?: boolean;
  children: React.ReactNode;
}

const TriggerSubScreenLayout: React.FC<TriggerSubScreenLayoutProps> = ({
  onBack,
  backLabel = 'Back to Triggers',
  showLiveBanner = false,
  hideBackButton = false,
  children,
}) => (
  <div className="space-y-4">
    {!showLiveBanner && !hideBackButton && (
      <div className="flex items-center gap-4 mb-6">
        <button
          onClick={onBack}
          className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          <span className="text-sm font-medium">{backLabel}</span>
        </button>
      </div>
    )}
    <LiveCampaignBanner show={showLiveBanner} />
    {children}
  </div>
);

export default TriggerSubScreenLayout;
